import { Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from 'src/app/views/utility/baseClass';

import { RegionService } from './region.service';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import Swal from 'sweetalert2';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { RegionmodalComponent } from '../../directives/regionmodal/regionmodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent extends BaseClass implements OnInit {
  @ViewChild('dt') dt: any;
  public tableData: any[] = [];
  excel_paragraph='';
  public selectedItem: MenuItem | null = null;
  public commonScrollHeight = '';
  public searchText: string;
  public ref: DynamicDialogRef | undefined;
  public first2: number = 0;
  public rows2: number = 10;
  public totalRecords: number = 0;
  exceldownloadModal=false;
  public options = [];
  public paginatorArray = [];
  public visible: boolean = false;
  public position = 'top';
  public cols = [];
  public _selectedColumns = [];
  message:GlobalMessage=new GlobalMessage();
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  searchTerm: string = '';
  hasLimitedAccess = "";
  isSupportAdmin = "";
  isSupportLimited = "N";


  constructor(
    public router: Router,
    public dialogService: DialogService,
    public utilityservice :Utilityservice,
    private regionService: RegionService,
    public override injector: Injector, // Make injector public here
    public PagehelpmodalService: PagehelpmodalService
  ) {
    super(injector);
    this.excel_paragraph=this.message.downloadexcel_text;
     this.utilityservice.configParams$.subscribe((data: any) => {
      const responseArray = data;
      if (responseArray) {
        const config = responseArray;
         this.hasLimitedAccess = config.haslimitedaccess; 
        this.isSupportAdmin = config.issupportadmin;
        if (this.hasLimitedAccess == "Y" && this.isSupportAdmin == "Y") {
          this.isSupportLimited = "Y";           
        }        
      } 
    });
    
     
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
    this.dynamiccols();
    this.utilityservice.getCSRFtoken();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'regionid', header: 'Region ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'regionname', header: 'Region', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: 'createdby', header: 'Created By', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'createdon', header: 'Created On', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'activeflag', header: 'Status', type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ];
    this._selectedColumns = this.cols;
  }

  getList() {
  const currentPageSize = this.rowsize;
 
  this.regionService.getRegionData().subscribe({
    next: (data: any) => {
      this.tableData = data;
      this.tableData = data.map(item => ({ ...item, isSelect: false }));
  
      this.options = this.utilityservice.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value);
  
      if (!this.paginatorArray.includes(currentPageSize)) {
        this.paginatorArray.push(currentPageSize);
        this.paginatorArray.sort((a, b) => a - b);
      }
  
      this.rowsize = currentPageSize;
      this.totalRecords = this.tableData.length;
      this.tablecount = data.count ?? data.length;
  
      setTimeout(() => {
        if (this.dt) {
          this.dt.first = this.currentPageIndex;
        }
      }, 0);
    },
    error: (error) => { 
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error?.error || "Error",
        text: `This error occurred at: ${timestamp}`,
        icon: "error",
      });
    }
  });
}

  closedpop() {
    this.visible = false;
  }

  show(title, data) {
    let details = {};
    if (title === 'Modify Region') {
      this.regionService.getRegionById(data.regionid, Number).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(RegionmodalComponent, {
          header: title,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details,isSupportLimited:this.isSupportLimited },
        });
        this.ref.onClose.subscribe(() => {
          this.getList();
        });
      });
    } else {
      details = {};
      this.ref = this.dialogService.open(RegionmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },
      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
   showDialog() {
        let payload={}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
      this.ref = this.dialogService.open(ExceldownloadComponent, {
        header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname:"Region_Master_Data.xlsx",downloadapi:'common/gen/regiondataexcel',method:'get',message:this.excel_paragraph,payload:payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
      });
    }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }


}
